/* ─────────────────────────────────────────────────────────────────────────────
   Sockologie — slim top navigation progress bar.

   On click of an internal content link, show a 3px brand-amber bar that eases
   toward ~85% while the next document loads; the browser swapping documents
   naturally discards it. Communicates "working" without hiding the page
   (replaces the full-screen iris as the loading signal; the iris now plays
   only once per session as a brand moment — see view-transitions.js).

   No-ops for: modified clicks (new tab), downloads, external links, cart/
   checkout/account paths, hash-only jumps, and bfcache restores.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var SKIP_PATH = /\/(cart|checkout|account|orders|apps|tools)(\/|$)/i;
  var bar = null;

  function makeBar() {
    var el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText =
      'position:fixed;top:0;left:0;height:3px;width:0;z-index:2147483000;' +
      'background:#E9B056;box-shadow:0 0 6px rgba(233,176,86,.7);' +
      'pointer-events:none;transition:width 2.2s cubic-bezier(0.15,0.6,0.3,1);';
    document.body.appendChild(el);
    return el;
  }

  function start() {
    if (bar) return;
    bar = makeBar();
    // two frames so the 0-width start state is committed before the ease begins
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (bar) bar.style.width = '85%';
      });
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.origin !== location.origin) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var samePage = a.pathname === location.pathname && a.search === location.search;
      if (samePage && a.hash) return; // in-page anchor
      if (SKIP_PATH.test(a.pathname || '')) return;
      start();
    },
    { capture: true }
  );

  // bfcache restore (back/forward): the old bar would still be in the DOM
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && bar) {
      bar.remove();
      bar = null;
    }
  });
})();
